import { render, staticRenderFns } from "./InformationHeader.vue?vue&type=template&id=4902c55e&scoped=true"
import script from "./InformationHeader.vue?vue&type=script&lang=js"
export * from "./InformationHeader.vue?vue&type=script&lang=js"
import style0 from "./InformationHeader.vue?vue&type=style&index=0&id=4902c55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4902c55e",
  null
  
)

export default component.exports